import "components/BounceLoader/BounceLoader.scss";

type BounceLoaderProps = {
  show: boolean;
};

export const BounceLoader = ({ show }: BounceLoaderProps) => {
  if (!show) return null;

  return (
    <div className="Bounce-Loader-Placeholder">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
};
